"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { MapPin } from "lucide-react";
export default function LocationMap() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const addressRef = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.3
  });
  return <section ref={sectionRef} className="relative w-full bg-dark-background/90 py-0" style={{
    minHeight: "30vh"
  }}>
      <div className={`relative w-full h-full transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        {}
        <div className="relative w-full overflow-hidden" style={{
        height: "30vh"
      }}>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.0867749878253!2d-122.41941568468185!3d37.77492977975903!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085809c6c8f4459%3A0xb10ed6d9b5050fa5!2sSan%20Francisco%2C%20CA!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus" width="100%" height="100%" style={{
          border: 0
        }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="MotoRevive Location Map" className="grayscale-[30%] contrast-110" />

          {}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none">
            <div className="relative animate-pulse">
              <MapPin className="text-primary drop-shadow-[0_0_8px_rgba(255,69,0,0.8)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-110" size={48} strokeWidth={2} fill="currentColor" />
            </div>
          </div>
        </div>

        {}
        <div ref={addressRef.ref} className={`absolute bottom-0 left-0 right-0 bg-primary/60 backdrop-blur-sm px-6 py-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${addressRef.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          <p className="text-foreground-primary text-center text-sm md:text-base font-medium">
            1234 Motorcycle Lane, Rider City, RC 56789
          </p>
        </div>
      </div>
    </section>;
}